/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../Redux/app/hooks";
import { Title } from "../components/styles";
import Filledbutton from "../components/Reusables/Buttons/Filledbutton";
import UnFilledbutton from "../components/Reusables/Buttons/PrimaryButton";
import * as LoginStyles from "../components/Generals/LoginStyles";
import { Desc } from "../components/Reusables/Cards/IconCard";
import OTPInputs from "../components/Reusables/Inputs/OTPInputs";
import { compileOtp, errorMessage } from "../Redux/Reducers/formReducer";
import { ResetUserPassword } from "../Apis/accountProcesing";
import { validateemail } from "../Helpers/generals";

const ConfirmResetOtp = () => {
  const navigate = useNavigate();
  const { otp, error, loading } = useAppSelector((state) => state.form);
  const email = localStorage.getItem("email");
  const dispatch = useAppDispatch();

  // verify and reset otp handlers
  const handleSubmit = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();

    const filteredOTP = otp.filter((x) => x.length !== 0);
    if (filteredOTP.length !== 6) {
      dispatch(errorMessage("OTP is not complete"));
    } else {
      navigate("/change-password");
      dispatch(compileOtp(filteredOTP.join("")));
    }
  };
  const handleResend = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (!email || !validateemail(email)) {
      dispatch(errorMessage("Please fill in a valid email"));
    } else {
      ResetUserPassword(email, navigate);
    }
  };

  useEffect(() => {
    if (!email) navigate("/create-account");
  });

  return (
    <LoginStyles.AuthPageContainer>
      <LoginStyles.FormLeftContainer href="https://switchwallet.io">
        <LoginStyles.AuthPageBanner src="/assets/images/Forms/Login-banner.png" />
      </LoginStyles.FormLeftContainer>
      <LoginStyles.FormContainer>
        <LoginStyles.Form>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "30px",
            }}
          >
            <Title>Confirm Mail</Title>
            <Desc>We have sent you a One Time Password to email</Desc>
          </div>

          <Desc style={{ marginBottom: "20px" }}>Please Enter OTP</Desc>
          <LoginStyles.InputContainer>
            <OTPInputs />
          </LoginStyles.InputContainer>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "20px",
              margin: "20px",
            }}
          >
            <UnFilledbutton
              text="Resend OTP"
              loading={loading}
              handleClick={handleResend}
            />
            <Filledbutton
              text="Verify OTP"
              loading={loading}
              handleClick={handleSubmit}
            />
          </div>
          <LoginStyles.FormFooter>
            <LoginStyles.FooterText>
              Already have an account?
            </LoginStyles.FooterText>
            <LoginStyles.FormLink to="/">Login</LoginStyles.FormLink>
          </LoginStyles.FormFooter>
          <div className="text-red" style={{ marginTop: "10px" }}>
            {error}
          </div>
        </LoginStyles.Form>
      </LoginStyles.FormContainer>
    </LoginStyles.AuthPageContainer>
  );
};

export default ConfirmResetOtp;
